import React, { FC, useEffect, useState } from 'react';
import { Container } from '@goldbely/explore-component-library';
import { Helmet } from 'react-helmet';

import BreakpointsService from 'src/explore/services/breakpoints';
import { IMerchant, INavItem } from 'src/prize/types/shoppe';

import Logo from '../../../../atoms/Logo';
import Buttons from './molecules/Buttons';
import Links from './molecules/Links';

import styles from './index.module.sass';

interface MietteProps {
  links?: INavItem;
  merchant: IMerchant;
}

const Miette: FC<MietteProps> = ({ links, merchant: { domain, logoImageUrl, name }}) => {
  const [ menuOpen, setMenuOpen ] = useState( false );
  const isMobile = BreakpointsService.lessThan( 'sm' );

  useEffect(() => {
    const handleKeyDown = ( event: KeyboardEvent ) => {
      if ( event.key === 'Escape' ) {
        setMenuOpen( false );
      }
    };
    document.addEventListener( 'keydown', handleKeyDown );
    return () => {
      document.removeEventListener( 'keydown', handleKeyDown );
    };
  }, []);

  return (
    <>
      <Helmet>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link
          href="https://fonts.googleapis.com/css2?family=Domine&family=Karla:ital,wght@0,200..800;1,200..800&display=swap"
          rel="stylesheet"
        />
      </Helmet>

      <div className={styles.wrap}>
        <Container>
          <Buttons isMobile={isMobile} onClickMenu={() => setMenuOpen(( state ) => !state )} />

          <Logo
            className={{ container: styles.logo }}
            image={logoImageUrl}
            link={domain}
            name={name}
          />

          <Links data={links} open={menuOpen} onClose={() => setMenuOpen( false )} />
        </Container>
      </div>
    </>
  );
};

export default Miette;
